import { render, staticRenderFns } from "./_UrlItem.vue?vue&type=template&id=dfd6df30&scoped=true&"
import script from "./_UrlItem.vue?vue&type=script&lang=js&"
export * from "./_UrlItem.vue?vue&type=script&lang=js&"
import style0 from "./_UrlItem.vue?vue&type=style&index=0&id=dfd6df30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd6df30",
  null
  
)

export default component.exports